import {
  actions,
  getBusinessGroupsubscriptionDatatableAsync,
  createNewBusinessGroupsubscriptionAsync,
  expireBusinessGroupsubscriptionAsync,
} from './slices';

export const BusinesssubscriptionActions = {
  ...actions,
  getBusinessGroupsubscriptionDatatableAsync,
  createNewBusinessGroupsubscriptionAsync,
  expireBusinessGroupsubscriptionAsync,
};
